import { FunctionComponent } from 'react';

const NotAuthorized: FunctionComponent = () => (
  <div className="text-center">
    <p>You don't have permissions to access this page.</p>
  </div>
);

export default NotAuthorized;